<template>
  <div>
    <TeJobIphoneCover />

    <TeJobAbout>
      <template #title>
        iPhoneアプリ
      </template>
      <template #content>
        <p class="co-display-10 mb-3 text-co-gray-500">
          Swiftを中心とした学習プログラムにおいて
          <br class="hidden md:block">
          受講生の「わからない」をリモートにてサポートしていただきます。
          <br class="hidden md:block">
          あなたのスキルを受講生の成長に活かしてみませんか？
        </p>
        <a href="/job">
          テックアカデミーのメンターについて
        </a>
      </template>
    </TeJobAbout>

    <TeJobTarget />

    <TeJobMessage>
      <template #mentoringText>
        1回30分のビデオチャットで受講生からの相談や質問に答えていただきます。
        <br class="hidden md:block">
        時にはペアプログラミングなどのサポートをしていただきます。
        <br class="hidden md:block">
        マンツーマンメンタリングはカリキュラムやチャットで解決できなかった課題を確実に解消させる取り組みです。
      </template>
      <template #chatsupportText>
        15時〜23時の間のシフト制で、
      </template>
    </TeJobMessage>

    <TeJobWorkStyle />

    <TeJobMentor>
      <template #mentorOne>
        <div class="basis-full px-4 text-center md:basis-1/4">
          <img
            src="~/assets/images/Te/TeJob/Mentor/mentor-shintaku.jpg"
            class="mx-auto mb-5 w-1/4 rounded-full md:mb-0 md:w-full"
            alt="Chiaki Shintaku"
            loading="lazy"
          >
        </div>
        <div class="basis-full px-0 text-left md:basis-3/4 md:px-4">
          <h4 class="co-display-10 text-center md:text-left">
            Chiaki Shintaku
          </h4>
          <p>
            プログラミング未経験からIT企業に入社。iOSアプリとAndroidアプリ開発に携わった後、独立。現在はフリーランスとしてiOSとAndroid、両方の開発に従事している。
          </p>
        </div>
      </template>
      <template #mentorTwo>
        <div class="basis-full px-4 text-center md:basis-1/4">
          <img
            src="~/assets/images/Te/TeJob/Mentor/mentor-umekawa.jpg"
            class="mx-auto mb-5 w-1/4 rounded-full md:mb-0 md:w-full"
            alt="Yuiko Umekawa"
            loading="lazy"
          >
        </div>
        <div class="basis-full px-0 text-left md:basis-3/4 md:px-4">
          <h4 class="co-display-10 text-center md:text-left">
            Yuiko Umekawa
          </h4>
          <p>
            プログラミング未経験者としてIT企業に入社。約2年半、WebアプリやiOSアプリ&#40;Swift&#41;のプロジェクトにて設計・製造業務に携わる。現在はフリーランスとして主にiOSアプリに関する業務を行っている。
          </p>
        </div>
      </template>
    </TeJobMentor>

    <TeJobMentorSlider />

    <!-- スキル -->
    <section
      id="skill"
      class="co-bg-striped"
    >
      <div class="co-container-lg px-4 pb-[3.75rem] pt-20 lg:pb-10">
        <h2 class="co-heading-2">
          iPhoneアプリメンターに必要なスキル
        </h2>
        <div class="grid grid-cols-1 justify-center gap-9 lg:grid-cols-2 lg:gap-x-8 lg:gap-y-10">
          <TeJobSkill>
            <template #icon>
              <img
                src="~/assets/images/Te/TeJob/Skill/curriculum-swift.png"
                alt="Swift"
                width="48"
                loading="lazy"
              >
            </template>
            <template #title>
              Swift
            </template>
            <template #description>
              Swiftの基礎知識、開発経験
            </template>
          </TeJobSkill>
          <TeJobSkill>
            <template #icon>
              <img
                src="~/assets/images/Te/TeJob/Skill/curriculum-xcode.png"
                alt="Xcode"
                width="48"
                loading="lazy"
              >
            </template>
            <template #title>
              Xcode
            </template>
            <template #description>
              Xcodeの基礎知識。iPhoneアプリ開発の実務経験（1年以上）
            </template>
          </TeJobSkill>
          <TeJobSkill>
            <template #icon>
              <img
                src="~/assets/images/Te/TeJob/Skill/curriculum-github.png"
                alt="Git/GitHub"
                width="48"
                loading="lazy"
              >
            </template>
            <template #title>
              Git/GitHub
            </template>
            <template #description>
              Gitの基礎知識とGitHub上でのソースコード管理経験
            </template>
          </TeJobSkill>
          <TeJobSkill>
            <template #icon>
              <img
                src="~/assets/images/Te/TeJob/Skill/curriculum-firebase.png"
                alt="Firebase"
                width="48"
                loading="lazy"
              >
            </template>
            <template #title>
              Firebase
            </template>
            <template #description>
              バックエンドサービスFirebaseの把握
            </template>
          </TeJobSkill>
        </div>
      </div>
    </section>

    <TeJobFlow />

    <TeJobEntry course-name-path="iphone" />
  </div>
</template>
<script setup lang="ts">
import { metaTags } from '~/utility/constants/metaTags'

import TeJobIphoneCover from '~/components/Te/TeJob/Iphone/TeJobIphoneCover.vue'
import TeJobAbout from '~/components/Te/TeJob/TeJobAbout.vue'
import TeJobTarget from '~/components/Te/TeJob/TeJobTarget.vue'
import TeJobMessage from '~/components/Te/TeJob/TeJobMessage.vue'
import TeJobWorkStyle from '~/components/Te/TeJob/TeJobWorkStyle.vue'
import TeJobMentor from '~/components/Te/TeJob/TeJobMentor.vue'
import TeJobMentorSlider from '~/components/Te/TeJob/TeJobMentorSlider.vue'
import TeJobSkill from '~/components/Te/TeJob/TeJobSkill.vue'
import TeJobFlow from '~/components/Te/TeJob/TeJobFlow.vue'
import TeJobEntry from '~/components/Te/TeJob/TeJobEntry.vue'

useJobHead()

useHead({
  title: 'iPhoneアプリ講師（メンター）募集 |テックアカデミー',
  meta: [
    ...metaTags({
      description:
        '受講生をサポートするiPhoneアプリメンター（講師）の募集ページ。在宅・リモートで全国どこからでも仕事ができ、時間も柔軟に対応可能。自身のプログラミングスキルを活用したい場合は、まずはお気軽にご応募ください。',
      twitterTitle: 'iPhoneアプリ講師（メンター）募集',
      twitterDescription:
        '受講生をサポートするiPhoneアプリメンター（講師）の募集ページ。在宅・リモートで全国どこからでも仕事ができ、時間も柔軟に対応可能。自身のプログラミングスキルを活用したい場合は、まずはお気軽にご応募ください。',
      twitterImage: '_nuxt/ogp/og-image-mentor-iphone.jpg',
      ogTitle: 'iPhoneアプリ講師（メンター）募集',
      ogDescription:
        '受講生をサポートするiPhoneアプリメンター（講師）の募集ページ。在宅・リモートで全国どこからでも仕事ができ、時間も柔軟に対応可能。自身のプログラミングスキルを活用したい場合は、まずはお気軽にご応募ください。',
      ogUrl: '/job/iphone',
      ogImage: '_nuxt/ogp/og-image-mentor-iphone.jpg',
    }),
  ],
})
</script>
